<template>
  <div>
    <el-card>
      <div class="container" v-for="item in tags" :key="item.id">
        <el-row>
          <el-col :span="12"><div class="circular" :style="getColorStyle(item.tag_col)"></div></el-col>
          <el-col :span="12"><div>{{item.tag_name}}</div></el-col>
        </el-row>
      </div>

    </el-card>
  </div>
</template>

<script>
import {getBlogTagList} from '../../../../request/api'

export default {
  name: 'BlogTagWidget',
  data () {
    return {
      tags: [] // blog标签数据
    }
  },
  methods: {
    init () {
      getBlogTagList().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.tags = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error
        console.log(error)
      })
    },
    getColorStyle (color) {
      return 'background-color:' + color
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>

.container{
  margin: 10px 0;
}

.circular{
  border-radius: 9px;
  width: 18px;
  height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/blog/BlogTagWidget.vue